import styled from "styled-components";

export const ContentDeliveries = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContentPercentage = styled.div`
  margin-right: 13px;
`;

export const ContainerTitle = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  p {
    margin: 0;
  }
`;
